import { gql } from 'react-apollo';

export default gql`
  mutation getBrokerageDocusignEnvelope($input: DocusignEnvelopeInput!) {
    getBrokerageDocusignEnvelope(input: $input) {
      url
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/mutations/getBrokerageDocusignEnvelope.js